import * as yup from "yup";

const forgotUserNameScheme = yup.object().shape({
  email: yup.string().required("Email is required"),
});

export default forgotUserNameScheme;
